import { useEffect, useState } from "react";
import { motion } from "framer-motion";
import { CheckCircle2 } from "lucide-react";
import { BrandLogo } from "@/components/BrandLogo";

const REDIRECT_URL = "https://elevatefinancialloans.com";
const REDIRECT_DELAY_MS = 5000;

export const SuccessScreen = () => {
  const [seconds, setSeconds] = useState(5);

  useEffect(() => {
    const tick = setInterval(() => {
      setSeconds((s) => (s > 0 ? s - 1 : 0));
    }, 1000);
    const redirect = setTimeout(() => {
      window.location.href = REDIRECT_URL;
    }, REDIRECT_DELAY_MS);
    return () => {
      clearInterval(tick);
      clearTimeout(redirect);
    };
  }, []);

  return (
    <div
      className="efl-page flex flex-col items-center justify-center px-4 py-12"
      data-testid="success-screen"
    >
      <motion.div
        initial={{ opacity: 0, y: 24, scale: 0.98 }}
        animate={{ opacity: 1, y: 0, scale: 1 }}
        transition={{ duration: 0.5, ease: [0.16, 1, 0.3, 1] }}
        className="w-full max-w-xl rounded-2xl bg-white px-8 py-12 sm:px-12 text-center shadow-[0_30px_80px_-30px_rgba(11,18,32,0.35)] border border-slate-100"
      >
        <div className="mb-8 flex justify-center">
          <BrandLogo variant="dark" size="md" testId="success-brand-logo" />
        </div>

        <motion.div
          initial={{ scale: 0 }}
          animate={{ scale: 1 }}
          transition={{ delay: 0.15, type: "spring", stiffness: 200, damping: 14 }}
          className="mx-auto mb-6 flex h-20 w-20 items-center justify-center rounded-full"
          style={{ background: "rgba(34,197,94,0.12)" }}
        >
          <CheckCircle2 size={48} className="text-emerald-500" strokeWidth={2} />
        </motion.div>

        <h1
          className="font-serif-brand text-3xl sm:text-4xl font-bold text-[#0f1a2e]"
          data-testid="success-heading"
        >
          Thank you for your application!
        </h1>
        <p
          className="mt-4 text-base text-slate-600 leading-relaxed"
          data-testid="success-body"
        >
          Your application has been submitted successfully. One of our
          representatives will call you and assist you further.
        </p>

        <div className="mt-8 h-px w-full bg-slate-100" />
        <p className="mt-6 text-sm text-slate-500" data-testid="redirect-countdown">
          Redirecting you to{" "}
          <span className="font-medium text-[#0f1a2e]">elevatefinancialloans.com</span>{" "}
          in {seconds} second{seconds === 1 ? "" : "s"}…
        </p>
      </motion.div>
    </div>
  );
};
